import { FormControl } from '@mui/material';
import { Controller } from 'react-hook-form';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { useTranslation } from 'react-i18next';
import { DATE_FORMATS } from '@callmart/types';
import ReactHookFormErrorLabel from './ReactHookFormErrorLabel';
import dayjs from '@utils/dayjs';

const ReactHookFormDateTimePicker = ({ name, label, control, defaultValue, rules, formErrors, minDate, ...props }) => {
    const { i18n } = useTranslation();

    return (
        <FormControl {...props} fullWidth={true}>
            <Controller
                name={name}
                control={control}
                defaultValue={defaultValue}
                rules={rules}
                render={({ field, fieldState }) => (
                    <>
                        <LocalizationProvider
                            adapterLocale={i18n.language}
                            dateAdapter={AdapterDayjs}
                            dateLibInstance={dayjs}
                        >
                            <DateTimePicker
                                {...field}
                                name={name}
                                slotProps={{ textField: { variant: 'outlined' } }}
                                label={label}
                                ampm={false}
                                inputFormat={`${DATE_FORMATS.DATE} ${DATE_FORMATS.TIME}`}
                                mask="__.__.____ __:__"
                                minDate={minDate}
                                {...props}
                            />
                        </LocalizationProvider>
                        {fieldState?.error && (
                            <ReactHookFormErrorLabel
                                fieldError={fieldState.error}
                                fieldName={name}
                                formErrors={formErrors}
                            ></ReactHookFormErrorLabel>
                        )}
                    </>
                )}
            />
        </FormControl>
    );
};

export default ReactHookFormDateTimePicker;
